import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';

const SENSITIVE_KEY =
  /(authorization|cookie|password|passwd|secret|token|api-?key|cpf|cnpj|credit|card)/i;

function scrubValue(key: string, value: unknown): unknown {
  if (SENSITIVE_KEY.test(key)) {
    return '[Filtered]';
  }

  if (typeof value === 'string' && value.toLowerCase().includes('bearer ')) {
    return '[Filtered]';
  }

  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const result: Record<string, unknown> = {};
    for (const [childKey, childValue] of Object.entries(
      value as Record<string, unknown>
    )) {
      result[childKey] = scrubValue(childKey, childValue);
    }
    return result;
  }

  return value;
}

export function initSentry(system: string, component: string): void {
  const sentry = environment.sentry;
  if (!sentry?.enabled || !sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    release: sentry.release || undefined,
    enabled: true,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    beforeSend(event) {
      if (
        event.level &&
        !['error', 'fatal'].includes(String(event.level).toLowerCase())
      ) {
        return null;
      }

      if (event.request?.headers) {
        event.request.headers = scrubValue(
          'headers',
          event.request.headers
        ) as Record<string, string>;
      }

      if (event.request) {
        delete event.request.cookies;
        delete event.request.query_string;
        delete event.request.data;
      }

      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }

      if (event.extra) {
        event.extra = scrubValue('extra', event.extra) as Record<
          string,
          unknown
        >;
      }

      event.tags = {
        ...event.tags,
        system,
        component,
        technology: 'angular',
      };

      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data) {
        const hasSensitive = Object.keys(breadcrumb.data).some(key =>
          SENSITIVE_KEY.test(key)
        );
        if (hasSensitive) {
          return null;
        }
      }

      if (
        typeof breadcrumb.message === 'string' &&
        breadcrumb.message.toLowerCase().includes('bearer ')
      ) {
        return null;
      }

      return breadcrumb;
    },
  });
}
